import { render, staticRenderFns } from "./HoverableDatatable.vue?vue&type=template&id=0dce453e&scoped=true&"
import script from "./HoverableDatatable.vue?vue&type=script&lang=ts&"
export * from "./HoverableDatatable.vue?vue&type=script&lang=ts&"
import style0 from "./HoverableDatatable.vue?vue&type=style&index=0&id=0dce453e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce453e",
  null
  
)

export default component.exports